var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"show-img-components"},[_c('img',{attrs:{"src":_vm.url,"alt":"图片"}})])}
var staticRenderFns = []

export { render, staticRenderFns }